import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule, RouteAccessService } from '../shared';
import { RouterModule } from '@angular/router';
import { FieldManagementMapComponent } from './field-management-map.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { StudyShapeGenerator } from './study-shape-generator';
import { ObservationUnitsService } from './service/observationUnits.service';
import { WorkbenchLocationService } from '../shared/workbench-location/service/workbench-location.service';
import { FieldMapContext } from './field-map-context.model';
import { WorkbenchLocationListComponent } from './workbench-location-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LocationStudyService } from '../shared/workbench-location/service/location-study.service';
import { ModalInputComponent } from './modal/modal-input.component';
import { PlotDetailsViewComponent } from './plot-details-view/plot-details-view.component';
import { StudyInstancesFilterSelectComponent } from './study-instance-filter-select/study-instances-filter-select.component';
import { StudyInstancesViewComponent } from './study-instances-view/study-instances-view.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LocationSearchComponent } from './location-search.component';
import { FIELD_MANAGEMENT_ROUTES } from './field-management.route';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(FIELD_MANAGEMENT_ROUTES),
        MatSidenavModule,
        ScrollingModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        HelpLinkComponent
    ],
    declarations: [
        FieldManagementMapComponent,
        WorkbenchLocationListComponent,
        ModalInputComponent,
        PlotDetailsViewComponent,
        StudyInstancesFilterSelectComponent,
        StudyInstancesViewComponent,
        LocationSearchComponent
    ],
    providers: [
        RouteAccessService,
        StudyShapeGenerator,
        ObservationUnitsService,
        WorkbenchLocationService,
        LocationStudyService,
        FieldMapContext
    ]
})
export class FieldManagementModule {
}
